import client from "network/client";

export function login(params) {
  const { post } = client();
  const {
    email,
    password,
    setIsLoggedIn,
    setPrimaryCalendarId,
    setToken,
    setErrorMessage,
  } = params;
  const body = { email, password };
  post({ url: "sessions", body: body })
    .then((data) => {
      if (data.token) {
        setToken(data.token);
        setIsLoggedIn(true);
        setPrimaryCalendarId(data.user.data.attributes.primary_calendar_id);
      } else if (data.error) {
        setErrorMessage(data.error);
      }
    })
    .catch((error) => {
      console.log(error);
      if (typeof error.json === "function") {
        error.json().then((errorBody) => {
          setErrorMessage(errorBody.error);
        });
      } else {
        setErrorMessage(error.message);
      }
    });
}
